import React from 'react';
import { useTranslation } from 'react-i18next';

import { CollectionForm } from '../CollectionForm';
import { BottomSheet } from '@/components/UI/BottomSheet/BottomSheet';

interface CollectionFormSheetProps {
  isOpen: boolean;
  onClose: () => void;
  mode?: 'create' | 'edit';
  onSuccess: () => void;
  hasDescription?: boolean;
}

export const CollectionFormSheet = ({
  mode = 'create',
  hasDescription = true,
  isOpen,
  onClose,
  onSuccess,
}: CollectionFormSheetProps) => {
  const { t } = useTranslation();

  return (
    <>
      <BottomSheet
        isPageLocked
        isTitleCentered
        isOpen={isOpen}
        close={onClose}
        onCloseClick={onClose}
        title={
          mode === 'create'
            ? t('bookmark_collections.form_title')
            : t('bookmark_collections.edit_collection_dropdown')
        }
      >
        <CollectionForm
          mode={mode}
          onSuccess={onSuccess}
          hasDescription={hasDescription}
        />
      </BottomSheet>
    </>
  );
};
